export function TooltipState(state) {
  return (
    {
      true: "Müşteriye ait telefon numarası onaylandı",
      false: "Müşteriye ait telefon numarası henüz onaylanmadı",
      assignment: "Bir bayiye atanmayı bekliyor",
      cancelled: "İptal Edildi",
      deleted: "Silindi",
      failed: "Başarısız oldu",
      in_queue: "Başlatılmayı bekliyor",
      in_progress: "İşlemde",
      approval: "Onay Bekliyor",
      completed: "Tamamlandı",
      pending: "Beklemede",
      sent_to_base: "Servise gönderiliyor",
      sent_to_reseller: "Bayiye gönderiliyor",
      received_by_base: "Servise ulaştı",
      received_by_reseller: "Bayiye ulaştı",
      eval_started: "İnceleniyor",
      pending_for_coverage: "Hizmet tutarı belirleniyor",
      customer_accepted: "Onarım ücreti müşteri tarafından onaylandı",
      customer_rejected: "Onarım ücreti müşteri tarafından onaylanmadı",
    }[state] || state
  );
}
